import {loginPath} from "./lib/clinicSignIn";
import axios from "axios";
const url = window.location.href.includes("localhost")
  ? "http://localhost:3000"
  : "https://server.brightlight.ai";

export function jwtDecode(t) {
  try {
    return JSON.parse(window.atob(t.split(".")[1]));
  } catch {
    window.location.href = loginPath();
  }
}

export async function loginUser(email, password, userType, db) {
  let config = {
    method: "POST",
    url: `${url}/login`,
    headers: {"Content-Type": "application/json"},
    data: JSON.stringify({
      email: email,
      password: password,
      userType: userType,
      db,
    }),
    withCredentials: true,
  };
  return await axios(config);
}

export async function resetUserEmail(email, userType, org) {
  let config = {
    method: "POST",
    url: `${url}/resetUser`,
    headers: {"Content-Type": "application/json"},
    // The clinic by its id, or by the name its sign-in page carries (/login/<db>), which is never told the id.
    data: JSON.stringify({email: email, userType: userType, ...(org?.oid ? {oid: org.oid} : {db: org?.db})}),
  };
  return await axios(config);
}

export async function checkResetParams(reset) {
  let config = {
    method: "POST",
    url: `${url}/checkResetParams`,
    headers: {"Content-Type": "application/json"},
    data: JSON.stringify({reset: reset}),
  };
  return await axios(config);
}

export async function resetPassword(reset, userId, password, userType, db, resetType) {
  let config = {
    method: "POST",
    url: `${url}/resetPassword`,
    headers: {"Content-Type": "application/json"},
    data: JSON.stringify({
      reset: reset,
      userId,
      password: password,
      userType,
      db,
      resetType,
    }),
    withCredentials: true,

  };
  return await axios(config);
}

export async function verifyUser(jwt, fadeInContent) {
  let config = {
    method: "POST",
    url: `${url}/verifyUser`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwt,
      "X-Tenant": 'patient',
    },
    data: JSON.stringify({id: jwt ? jwtDecode(jwt)?.id : ""}),
    withCredentials: true,
  };
  axios(config)
    .then(() => {
      var fc = 0;
      fadeInContent?.current &&
        (function fade() {
          if (fadeInContent?.current) {
            fadeInContent.current.style.opacity = fc = fc + 0.1;
            fadeInContent.current.style.opacity != 1 && setTimeout(fade, 30);
          }
        })();
      return;
    })
    .catch((e) => {
      console.log(e);
      window.location.href = loginPath();
    });
}

// The second step of a two-step sign-in. `jwt` is the second-step token the
// password step answered with; a right code answers with the session itself —
// its cookie, which is why this request carries credentials, and its token
// (`data.jwt`), which replaces the second-step one.
export async function verifyLoginCode({jwt, code, userType, user, db}) {
  let config = {
    method: "POST",
    url: `${url}/verifyLoginCode`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwt,
    },
    data: JSON.stringify({id: jwtDecode(jwt).id, code, userType, user, db}),
    withCredentials: true,
  };
  return axios(config);
}

export function setAuthCode({jwt, userType, user, db, organization}) {
  let config = {
    method: "POST",
    url: `${url}/setAuthCode`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwt,
    },
    data: JSON.stringify({
      id: jwtDecode(jwt).id,
      userType,
      user,
      db,
      organization,
    }),
    withCredentials: true,
  };
  return axios(config);
}

export async function changePassword(state, updateBody) {
  let configNotifications = {
    method: "POST",
    url: `${url}/changePassword`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
      "X-Tenant": 'patient',
    },
    data: JSON.stringify({
      id: jwtDecode(state.jwt).id,
      updateBody: updateBody,
      db: state.organization?.db,

    }),
  };

  return await axios(configNotifications);
}

export function logoutUser() {
  window.location.href = loginPath();
}

export async function validateUrlTempForms(params) {
  let config = {
    method: "POST",
    url: `${url}/validateUrlTempForms`,
    headers: {"Content-Type": "application/json", "X-Tenant": 'patient'},
    data: {params: params},
  };
  return await axios(config);
}

// `/submit-form` now requires proof, and there are two legitimate kinds.
//
//   params  the encrypted blob from the emailed link. It carries the tenant and
//           the fsid inside it, so the server does not have to trust either
//           from the body - which is what it used to do, with no check at all.
//   jwt     a signed-in session, for the same form opened inside the portal.
//
// Sending neither is a 404, by design.
export async function submitForm(db, fsid, formData, options = {}) {
  const {params, jwt, ...rest} = options;
  let config = {
    method: "POST",
    url: `${url}/submit-form`,
    headers: {
      "Content-Type": "application/json",
      "X-Tenant": jwt ? db : "patient",
      ...(jwt ? {Authorization: "Bearer " + jwt} : {}),
    },
    withCredentials: true,
    data: {db: db, fsid: fsid, formData: formData, ...(params ? {params} : {}), ...rest},
  };
  return await axios(config);
}

export async function getLocations(db, linkId) {
  let config = {
    method: "POST",
    url: `${url}/getLocations`,
    headers: {"Content-Type": "application/json"},
    data: {db: db, linkId: linkId},
  };
  return await axios(config);
}

